import { motion } from "framer-motion";

export const FINE_POINTER =
  typeof window !== "undefined" && window.matchMedia?.("(pointer: fine)").matches;

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => {
  // Touch devices render content instantly — no in-view trigger to ever get
  // stuck invisible (and faster first paint). Desktop keeps the reveal.
  if (!FINE_POINTER) {
    return (
      <div className={className} {...rest}>
        {children}
      </div>
    );
  }
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const Crosshair = ({ className = "" }) => (
  <span
    className={`pointer-events-none absolute z-10 h-3 w-3 border-gold/80 ${className}`}
    aria-hidden="true"
  />
);
